import { render, staticRenderFns } from "./_matchClearRs.vue?vue&type=template&id=01fd8fb4&scoped=true&lang=pug&"
import script from "./_matchClearRs.vue?vue&type=script&lang=js&"
export * from "./_matchClearRs.vue?vue&type=script&lang=js&"
import style0 from "./_matchClearRs.vue?vue&type=style&index=0&id=01fd8fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd8fb4",
  null
  
)

export default component.exports